import { useEffect } from "react";
import { useLocation } from "react-router";

const root = document.getElementById("root");

export const useScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    root?.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
};

export const useScrollToTopByState = (state: unknown) => {
  useEffect(() => {
    root?.scrollTo({ top: 0, behavior: "instant" });
  }, [state]);
};
